import { useEffect, useState } from "react";

/**
 * React 17 has no `useSyncExternalStore`. This is a minimal shim good enough for
 * our external dock stores: subscribe + local state + re-read on notify.
 *
 * `subscribe` and `getSnapshot` MUST be stable (module-level) functions.
 */
export function useVisualizerStore<T>(
  subscribe: (onChange: () => void) => (() => void) | void,
  getSnapshot: () => T,
): T {
  const [state, setState] = useState<T>(getSnapshot);

  useEffect(() => {
    let mounted = true;
    const onChange = () => {
      if (mounted) setState(getSnapshot());
    };
    // Re-read once in case the value changed between render and effect.
    onChange();
    const unsubscribe = subscribe(onChange);
    return () => {
      mounted = false;
      unsubscribe && unsubscribe();
    };
  }, [subscribe, getSnapshot]);

  return state;
}

export default useVisualizerStore;
